import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import AbiShell from "@/pages/abi/AbiShell";
import { Switch } from "@/components/ui/switch";
import { Badge } from "@/components/ui/badge";
import { ExternalLink, Database } from "lucide-react";

const TIPO_LABEL = { istituzionale: "Istituzionale", aziendale: "Aziendale", privato: "Database privato", web: "Web" };
const STATO_META = {
  pianificata: { label: "Pianificata (FASE 2)", cls: "bg-violet-100 text-violet-700" },
  manuale: { label: "Verifica manuale", cls: "bg-amber-100 text-amber-700" },
  pagamento: { label: "A pagamento", cls: "bg-slate-200 text-slate-700" },
};

export default function AbiFonti() {
  const [sources, setSources] = useState([]);
  const [livelli, setLivelli] = useState({});
  const [isAdmin, setIsAdmin] = useState(false);

  const load = () => {
    api.get("/abi/sources").then(({ data }) => {
      setSources(data.sources); setLivelli(data.livelli); setIsAdmin(data.is_admin);
    }).catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)));
  };
  useEffect(() => { load(); }, []);

  const toggle = async (s, attiva) => {
    try {
      await api.post(`/abi/sources/${s.id}/toggle`, { attiva });
      setSources((prev) => prev.map((x) => x.id === s.id ? { ...x, attiva } : x));
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  return (
    <AbiShell>
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-10" data-testid="abi-fonti-page">
        <div className="flex items-center gap-2 mb-1"><Database className="h-5 w-5 text-violet-600" /><h1 className="font-heading text-2xl font-semibold text-slate-900">Fonti dati</h1></div>
        <p className="text-sm text-slate-500 mb-6">Registro modulare dei Source Adapter. {isAdmin ? "Puoi attivare/disattivare le fonti automatiche." : "Attivazione riservata alla Direzione."}</p>

        <div className="space-y-2.5">
          {sources.map((s) => {
            const lv = livelli[s.livello] || {};
            const st = STATO_META[s.stato] || { label: s.stato, cls: "bg-slate-100 text-slate-600" };
            return (
              <div key={s.id} className="rounded-xl border border-slate-200 bg-white p-4 flex items-start gap-4" data-testid={`abi-source-${s.id}`}>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-medium text-slate-800">{lv.badge} {s.label}</span>
                    <Badge variant="outline" className="text-[10px]">{TIPO_LABEL[s.tipo] || s.tipo}</Badge>
                    {s.ufficiale && <Badge className="bg-emerald-100 text-emerald-700 text-[10px]">Ufficiale</Badge>}
                    <Badge className={`text-[10px] ${st.cls}`}>{st.label}</Badge>
                    {!s.gratuita && <Badge className="bg-slate-200 text-slate-700 text-[10px]">Non gratuita</Badge>}
                  </div>
                  <p className="text-xs text-slate-500 mt-1">{s.note}</p>
                  {s.url && <a href={s.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-xs text-violet-600 hover:underline mt-1" data-testid={`abi-source-open-${s.id}`}><ExternalLink className="h-3 w-3" /> Apri fonte</a>}
                </div>
                <div className="flex flex-col items-end gap-1 shrink-0">
                  <span className="text-[10px] uppercase tracking-wide text-slate-400">{s.auto ? "Automatica" : "Manuale"}</span>
                  <Switch checked={!!s.attiva} disabled={!isAdmin || !s.auto} onCheckedChange={(v) => toggle(s, v)} data-testid={`abi-source-toggle-${s.id}`} />
                </div>
              </div>
            );
          })}
        </div>
      </main>
    </AbiShell>
  );
}
